<template>
<div class="chapter">
<div class="inner_page">
<p class="imageb"><a id="cont"></a><a id="page_6"><img alt="image" height="475px" src="images/f0006-01.jpg"/></a></p><a id="page_6">
</a><h2 class="h2r"><a id="page_6"></a><a id="page_7"><strong>CONTENTS</strong></a></h2><a id="page_7">
</a><p class="cont"><a id="page_7"></a><a class="nounder" href="#/xhtml/intro#intro"><strong>INTRODUCTION</strong><br/>Make Room for Fantastically Full</a></p>
<p class="cont"><a class="nounder" href="#/xhtml/ch01#ch01"><strong>CHAPTER 1</strong><br/>Your Complete Prep Guide to Wicked Good Meals</a></p>
<p class="cont"><a class="nounder" href="#/xhtml/ch02#ch02"><strong>CHAPTER 2</strong><br/>Down-Home Breakfasts</a></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><strong>CHAPTER 3</strong><br/>Mean and Mouthwatering Mains</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><strong>CHAPTER 4</strong><br/>Over-the-Top, Totally Tantalizing Sides</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><strong>CHAPTER 5</strong><br/>The Bottomless Bread Basket</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><strong>CHAPTER 6</strong><br/>Condiments, Sauces, and Other Staples</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><strong>CHAPTER 7</strong><br/>Ooey, Gooey, and Downright Sinful Sweets</span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cont2"><span class="nounder" href="#/xhtml/about#about" title="Link target outside of Sample">About the Authors</span></p>
<p class="cont2"><span class="nounder" href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
<p class="image"><a id="page_8"><img alt="image" height="475px" src="images/f0008-01.jpg"/></a></p><a id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?7f3146dc